<template>
  <v-file-input
    v-model="file"
    v-bind="fieldProps"
    :rules="rules"
    :name="file ? 'file' : ''"
    label="Anexo"
    accept="audio/*,video/*,image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  ></v-file-input>
</template>

<script>
// import { fileExtensionValidation } from "../validations/fileExtensionValidation";
import { mixin } from "./mixin";

export default {
  data: () => ({
    file: null,
    // rules: [fileExtensionValidation(["pdf", "doc", "docx"])],
  }),
  mixins: [mixin],
};
</script>
